import template from './rw-prior-period-year.html';

class RwPriorPeriodYearController {
  handleClick(value) {
    this.action({ value });
  }
}

export default class RwPriorPeriodYearComponent {
  constructor() {
    this.template = template;
    this.transclude = true;
    this.controller = RwPriorPeriodYearController;
    this.bindings = {
      action: '&',
      year: '<?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-prior-period-year/rw-prior-period-year-component.js